<template>
    <page-section class="page-section--xs">
        <template slot="containerImmersive">
            <div class="pb-4 pb-md-5">
                <v-row justify="space-between" align="center">
                    <v-col cols="auto">
                        <h3 class="tit tit--xs">출고목록</h3>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn v-bind="{ loading }" color="primary" width="114" class="rounded-sm" @click="exec">발송하기</v-btn>
                    </v-col>
                </v-row>
            </div>
            <v-simple-table v-bind="{ headers }" dense class="v-data-table--default v-data-table--no-hover inventory-form-table">
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header.value">
                            {{ header.text }}
                        </th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cart in carts" :key="cart._purchase">
                        <td>{{ cart.fullName || "-" }}</td>
                        <td>{{ cart?.code || "-" }}</td>
                        <td>{{ cart?.stockedAt?.toDate?.() || cart?.stockedAt || "-" }}</td>
                        <td>
                            <div class="quantity-controller">
                                <v-btn v-bind="{ loading }" icon tile class="v-size--xx-small transparent" @click="decrease(cart)">
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                                <input
                                    v-model="cart.amount"
                                    v-bind="{
                                        min: 1,
                                        max: cart.amount_max,
                                        type: 'number',
                                    }"
                                    @input="onInputAmount(cart)"
                                />
                                <v-btn v-bind="{ loading }" icon tile class="v-size--xx-small transparent" @click="increase(cart)">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </td>
                        <td>{{ cart?.purchasePrice__unit?.format?.() || 0 }}</td>
                        <td>{{ getPurchasePrice__total(cart)?.format?.() || 0 }}</td>
                        <td>
                            <v-btn v-bind="{ loading }" icon text color="red" @click="pull(cart)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </template>
    </page-section>
</template>

<script>
import PageSection from "@/components/client/templates/page-section.vue";
import api from "@/api";

const headers = [
    { value: "fullName", text: "상품명" },
    { value: "code", text: "상품코드" },
    { value: "stockedAt", text: "입고일", formatter: (value) => value?.toDate?.() || value || "-" },
    { value: "amount", text: "재고수량", formatter: (value) => value?.format?.() || "-" },
    { value: "purchasePrice__unit", text: "평균 매입 단가", formatter: (value) => value?.format?.() || "-" },
    { value: "purchasePrice__total", text: "총액(수량X단가)", formatter: (value) => value?.format?.() || "-" },
];

export default {
    components: {
        PageSection,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected (purchases)
    },
    setup: () => ({
        headers,
    }),
    data: () => ({
        carts: [],
        loading: false,
    }),
    computed: {},
    methods: {
        sync() {
            this.carts = this.value.map((purchase) => {
                let cart = this.carts.find((cart) => purchase._id == cart._purchase);
                if (cart) return cart;

                let {
                    //
                    _id: _purchase,
                    _product,
                    _option,
                    _supply,
                    fullName,
                    code,
                    createdAt: stockedAt,
                    amount,
                    amount_out,
                    purchasePrice__unit,
                } = purchase;

                return {
                    _purchase,
                    _product,
                    _option,
                    _supply,
                    fullName,
                    code,
                    stockedAt,
                    amount: 1,
                    amount_max: amount - amount_out,
                    purchasePrice__unit,
                    deliveryType: "stout",
                };
            });
        },
        pull(cart) {
            let index = this.carts.findIndex((item) => item._purchase == cart._purchase);
            if (-1 < index) {
                this.carts.splice(index, 1);

                let [...value] = this.value;
                value.splice(index, 1);
                this.$emit("input", value);
            }
        },
        async exec() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { carts } = this;
                carts = (await api.v1.me.carts.post({ carts, mode: "buy" }))?.carts;
                this.$store.dispatch("addToCart", carts);

                let _carts = carts.map(({ _id }) => _id);
                this.$store.dispatch("pickup", _carts);

                this.$router.push({ path: "/shop/order?deliveryType=stout" });
            } finally {
                this.loading = false;
            }
        },

        getPurchasePrice__total(cart) {
            return cart.amount * cart.purchasePrice__unit;
        },

        decrease(cart) {
            if (cart.amount <= 1) cart.amount = 1;
            else cart.amount -= 1;
        },
        increase(cart) {
            if (cart.amount_max <= cart.amount) cart.amount = cart.amount_max;
            else cart.amount += 1;
        },
        onInputAmount(cart) {
            this.$nextTick(() => {
                if (cart.amount <= 1) cart.amount = 1;
                if (cart.amount_max <= cart.amount) cart.amount = cart.amount_max;
            });
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.inventory-form-table {
    --border-color: var(--v-grey-lighten4);
    th,
    td {
        text-align: center !important;
        padding: 12px !important;
        &:not(:last-child) {
            border-right: 1px solid var(--border-color);
        }
    }
    th {
        white-space: nowrap;
    }
    thead {
        > tr {
            > th {
                // &:nth-child(1) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(2) {
                //     width: calc(160.5 / 894 * 100%);
                // }
                // &:nth-child(3) {
                //     width: calc(108 / 894 * 100%);
                // }
                // &:nth-child(4) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(5) {
                //     width: calc(184.5 / 894 * 100%);
                // }
                // &:nth-child(6) {
                //     width: calc(48 / 894 * 100%);
                // }
            }
        }
    }
}

.quantity-controller {
    display: flex;
    align-items: center;
    width: fit-content;
    height: 28px !important;
    margin: 0 auto;
    background: transparent;
    border: 1px solid var(--v-grey-lighten3);
    border-radius: 6px;
    overflow: hidden;
    input {
        width: 28px;
        height: 26px;
        text-align: center;
        color: var(--v-grey-base);
    }
}
</style>
